import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import InfoIcon from '@mui/icons-material/Info'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import PersonRemoveIcon from '@mui/icons-material/PersonRemove'
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'
import * as React from 'react'

import CButton from './CButton'

/**
 * 通用的菜单操作组件
 * @param {Object} props
 * @param {boolean} [props.viewable=false] - 是否显示查看详情选项
 * @param {function} [props.onView] - 查看详情回调
 * @param {boolean} [props.editable=false] - 是否显示编辑选项
 * @param {function} [props.onEdit] - 编辑回调
 * @param {boolean} [props.unregisterable=false] - 是否显示取消注册选项
 * @param {function} [props.onUnregister] - 取消注册回调
 * @param {boolean} [props.deleteable=false] - 是否显示删除选项
 * @param {function} [props.onDelete] - 删除回调
 * @returns {JSX.Element}
 */
export default function MenuAction({
  viewable = false,
  onView = () => {},
  editable = false,
  onEdit = () => {},
  unregisterable = false,
  onUnregister = () => {},
  deleteable = false,
  onDelete = () => {},
  exportable = false,
  onExport = () => {},
}) {
  const [anchorEl, setAnchorEl] = React.useState(null)

  const menuItemSx = {
    py: 0.5,
  }

  const handleMenuClick = (event) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = (event) => {
    event.stopPropagation()
    setAnchorEl(null)
  }

  const handleAction = (callback) => (event) => {
    event.stopPropagation()
    handleMenuClose(event)
    callback?.()
  }

  return (
    <>
      <CButton title="Menu" onClick={handleMenuClick}>
        <MoreVertIcon
          sx={(theme) => ({
            color: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(255, 255, 255, 0.8)',
          })}
        />
      </CButton>
      <Menu id="long-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleMenuClose} onClick={(e) => e.stopPropagation()}>
        {viewable && (
          <MenuItem onClick={handleAction(onView)} sx={menuItemSx}>
            <ListItemIcon>
              <InfoIcon fontSize="small" color="primary" />
            </ListItemIcon>
            <ListItemText>View Details</ListItemText>
          </MenuItem>
        )}
        {editable && (
          <MenuItem onClick={handleAction(onEdit)} sx={menuItemSx}>
            <ListItemIcon>
              <EditIcon fontSize="small" color="info" />
            </ListItemIcon>
            <ListItemText>Edit</ListItemText>
          </MenuItem>
        )}
        {unregisterable && (
          <MenuItem onClick={handleAction(onUnregister)} sx={menuItemSx}>
            <ListItemIcon>
              <PersonRemoveIcon fontSize="small" color="warning" />
            </ListItemIcon>
            <ListItemText>Unregister</ListItemText>
          </MenuItem>
        )}
        {deleteable && (
          <MenuItem onClick={handleAction(onDelete)} sx={menuItemSx}>
            <ListItemIcon>
              <DeleteIcon fontSize="small" color="error" />
            </ListItemIcon>
            <ListItemText>Delete</ListItemText>
          </MenuItem>
        )}
        {exportable && (
          <MenuItem onClick={handleAction(onExport)} sx={menuItemSx}>
            <ListItemIcon>
              <FileDownloadIcon fontSize="small" color="primary" />
            </ListItemIcon>
            <ListItemText>Export to CSV</ListItemText>
          </MenuItem>
        )}
      </Menu>
    </>
  )
}
